/* eslint-disable
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import * as d3 from 'd3';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import {assert, assertAndContinue} from 'Asserts';
import BenchlingCollection from 'BenchlingCollection';
import {Sequence as BioJSSequence} from 'biojs/Sequence';
import {Sequence} from 'components/Sequence';
import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import {ASSEMBLY_TYPE} from 'constants/AssemblyConstants';
import {FolderSummary} from 'constants/FolderConstants';
import FileStates from 'FileStates';
import Enzymes, {Enzyme} from 'molbio/enzymes/backbone/Enzymes';
import {EnzymePreferences, ProviderName} from 'molbio/enzymes/EnzymeConstants';
import * as sequtil from 'molbio/SeqUtil';
import notifications, {GenericResponseJSON} from 'notifications';
import preferences from 'Preferences';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import * as net from 'util/Net';

const COMMON_ENZYMES = Enzymes.getCommonEnzymes();

export interface AssemblyWizardFragmentSequenceMetadata {
  id: string;
  name: string;
  folder: FolderSummary;
}

interface AssemblyWizardFragment {
  sequenceID: string | null;
  active: boolean;
  reverse: boolean;
  startEnzymeID: number | null;
  endEnzymeID: number | null;
  sequenceMetadata: AssemblyWizardFragmentSequenceMetadata | null;
  start: number | null;
  end: number | null;
  name?: string;
}

type ServerAssemblyWizardFragment = Omit<
  AssemblyWizardFragment,
  'sequenceId' | 'startEnzymeId' | 'endEnzymeId' | 'sequenceMetadata'
> & {
  sequence_id: string | null;
  start_enzyme_id: number | null;
  end_enzyme_id: number | null;
  sequence_metadata: AssemblyWizardFragmentSequenceMetadata | null;
};

class Fragment extends Backbone.Model {
  sequences!: FileStates;

  static initClass(): void {
    this.prototype.urlRoot = '/1/api/fragments/';
  }

  defaults(): AssemblyWizardFragment {
    return {
      sequenceID: null,
      active: false,
      reverse: false,
      startEnzymeID: null,
      endEnzymeID: null,
      sequenceMetadata: null,
      start: null,
      end: null,
    };
  }

  startEnzymeID(): number | null {
    return this.get('startEnzymeID');
  }

  endEnzymeID(): number | null {
    return this.get('endEnzymeID');
  }

  enzymeIDs(): [number, number] | null {
    if (this.startEnzymeID() != null && this.endEnzymeID() != null) {
      return [this.startEnzymeID()!, this.endEnzymeID()!];
    }
    return null;
  }

  start(): number | null {
    return this.get('start');
  }

  end(): number | null {
    return this.get('end');
  }

  sequenceID(): string | null {
    return this.get('sequenceID');
  }

  reverse(): boolean {
    return this.get('reverse');
  }

  sequenceMetadata(): AssemblyWizardFragmentSequenceMetadata {
    return this.get('sequenceMetadata');
  }

  initialize(): void {
    this.sequences = require('FileStates').default.get();
  }

  /**
   * Calculates the length of the fragment.
   */
  length(): number {
    return sequtil.length(this.start()!, this.end()!, this.getSequence()!.length());
  }

  /**
   * Checks that the fragment is valid for assembly.
   *
   * Specifically:
   * 1) checks that the fragment does not wrap unless the sequence is circular
   * 2) checks that the fragment indices fall within the sequence length
   * 3) checks that the fragment can be created by enzyme digest if it is configured as such
   */
  isValid(): boolean {
    const sequence = this.getSequence()!;
    // Check sequence topology.
    if (!sequence.circular() && sequtil.isWrap(this.start()!, this.end())) {
      return false;
    }
    // Check fragment doesn't extend past end.
    if (this.start()! >= sequence.length() || this.end()! >= sequence.length()) {
      return false;
    }
    // If digested, check that fragment still matches.
    if (this.enzymeIDs() != null) {
      const seqFragment = this.getSelectedFragmentFromSequence(sequence, {raiseOnNotFound: false});
      if (seqFragment == null) {
        return false;
      }
    }
    return true;
  }

  getSequence(): Sequence | null {
    const sequenceID = this.sequenceID();
    if (sequenceID == null) {
      return null;
    }
    const fileState = this.sequences.get(sequenceID);
    if (fileState == null) {
      return null;
    }
    return fileState.get('sequence');
  }

  getEnzymes(): Array<{color: string; name: string; offset: number}> | null {
    if (this.enzymeIDs() != null) {
      const sequence = this.getSequence()!;
      return this.enzymeIDs()!.map((enzymeID) => {
        const enzyme = sequence.get('enzymes').get(enzymeID);
        return {
          color: d3.rgb(enzyme.color()!).darker(0.5).formatHex(),
          name: enzyme.name(),
          offset: enzyme.offset(),
        };
      });
    }
    return null;
  }

  getSelectedFragmentFromSequence(
    sequence: Sequence,
    {raiseOnNotFound = true}: {raiseOnNotFound?: boolean} = {}
  ): BioJSSequence | null {
    const enzymeIds = this.enzymeIDs()!;
    const seqFragments = sequence.getFragments(enzymeIds);
    const selectedFragment = this.getSelectedFragment(seqFragments);
    if (raiseOnNotFound) {
      assert(selectedFragment != null, 'Expected a fragment to be selected', {
        enzymeIds,
        seqFragments: seqFragments.map((f) => ({start: f.get('start'), end: f.get('end')})),
        sequenceId: sequence.id,
      });
    }
    return selectedFragment;
  }

  getSelectedFragment(fragments: Backbone.Collection<BioJSSequence>): BioJSSequence | null {
    let fragment;
    const stepStart = this.start()!;
    const stepEnd = this.end()!;

    const sequence = this.getSequence()!;
    const _sequence = sequence.get('_sequence');
    const startFragment = fragments.find((fragment) => fragment.get('start') === stepStart);
    const endFragment = fragments.find((fragment) => fragment.get('end') === stepEnd);

    if (startFragment == null || endFragment == null) {
      return null;
    }

    let start = startFragment.get('start')!;
    const offset5 = startFragment.get('offset5');
    start = offset5 > 0 ? start : start + offset5;
    start = sequtil.mod(start, sequence.length());

    let end = endFragment.get('end')!;
    const offset3 = endFragment.get('offset3');
    end = offset3 < 0 ? end : end + offset3;
    end = sequtil.mod(end, sequence.length());

    const options = {annotations: true, notcontained: true};
    if (stepStart === stepEnd) {
      let bases;
      start = sequtil.mod(stepStart + offset5, sequence.length());
      if (offset5 > 0) {
        fragment = _sequence.clone();
        fragment.opReindex({current: stepStart, desired: 0});
        fragment.set({circular: false});
        bases = _sequence.residueSlice(stepEnd, start, true);
        fragment.opInsert({pos: fragment.length(), bases});
      } else {
        fragment = _sequence.clone();
        fragment.opReindex({current: start, desired: 0});
        fragment.set({circular: false});
        bases = _sequence.residueSlice(start, stepEnd, true);
        fragment.opInsert({pos: fragment.length(), bases});
      }
    } else {
      fragment = _sequence.createFromIndices(start, end, options);
    }
    fragment.set({
      offset5,
      offset3,
      _cutter5: startFragment.get('_cutter5'),
      _cutter3: endFragment.get('_cutter3'),
      start: stepStart,
      end: stepEnd,
    });
    return fragment;
  }

  open(): void {
    const sequence = this.getSequence()!;
    const sequenceFragment = sequence._sequence().slice(this.start()!, this.end()!);
    sequenceFragment.set({start: this.start()!, end: this.end()!});
    const fileStates = require('FileStates').default.get();
    fileStates.selectFragment(sequence, sequenceFragment);
  }

  parse(resp: ServerAssemblyWizardFragment): AssemblyWizardFragment {
    // eslint-disable-next-line no-restricted-syntax
    resp = _.extend(resp, {
      sequenceID: resp.sequence_id,
      startEnzymeID: resp.start_enzyme_id,
      endEnzymeID: resp.end_enzyme_id,
      sequenceMetadata: resp.sequence_metadata,
    });

    // eslint-disable-next-line no-restricted-syntax
    return _.omit(resp, 'sequence_id', 'start_enzyme_id', 'end_enzyme_id');
  }

  toJSON(): Omit<ServerAssemblyWizardFragment, 'sequence_metadata'> {
    const json = super.toJSON(...arguments);
    // eslint-disable-next-line no-restricted-syntax
    _.extend(json, {
      sequence_id: json.sequenceID,
      start_enzyme_id: json.startEnzymeID,
      end_enzyme_id: json.endEnzymeID,
    });

    // eslint-disable-next-line no-restricted-syntax
    return _.omit(json, 'sequenceID', 'startEnzymeID', 'endEnzymeID', 'sequenceMetadata');
  }
}

Fragment.initClass();

class Fragments extends Backbone.Collection<Fragment> {
  static initClass(): void {
    this.prototype.model = Fragment;
  }
}

Fragments.initClass();

interface AssemblyWizardSlot {
  name: string | null;
  type: unknown;
  index: number | null;
  fragments: Fragments;
  method: ASSEMBLY_TYPE | null;
  active: boolean;
  warnings: Array<string>;
  errors: Array<string>;
  spacer?: string | null;
}

type ServerAssemblyWizardSlot = Pick<AssemblyWizardSlot, 'index' | 'name' | 'spacer' | 'type'> & {
  id: number;
  fragments: Array<ServerAssemblyWizardFragment>;
};

class AssemblySlot extends Backbone.Model {
  static initClass(): void {
    this.prototype.urlRoot = '/1/api/slots/';
  }

  defaults(): AssemblyWizardSlot {
    return {
      name: null,
      type: null,
      index: null,
      fragments: new Fragments(),
      method: null,
      active: false,
      warnings: [],
      errors: [],
    };
  }

  initialize(): void {
    this.listenTo(
      this.fragments(),
      'add remove',
      function (model: Fragment, collection: Fragments, options: {skipCheck: boolean}) {
        // @ts-expect-error Shadows outer this
        return this.trigger('slotChange', options);
      }
    );
    this.listenTo(this.fragments(), 'change', function (model: Fragment, options: {skipCheck: boolean}) {
      // @ts-expect-error Shadows outer this
      return this.trigger('slotChange', options);
    });
    this.listenTo(
      this.fragments(),
      'reset',
      function (
        collection: Fragments,
        options: {
          skipCheck: boolean;
        }
      ) {
        // @ts-expect-error Shadows outer this
        return this.trigger('slotChange', options);
      }
    );
  }

  active(): boolean {
    return this.get('active');
  }

  errors(): Array<string> {
    return this.get('errors');
  }

  fragments(): Fragments {
    return this.get('fragments');
  }

  index(): number | null {
    return this.get('index');
  }

  isEmpty(): boolean {
    return this.fragments().length === 0;
  }

  method(): ASSEMBLY_TYPE {
    return this.get('method');
  }

  name(): string | null {
    return this.get('name');
  }

  displayName(): string | null {
    if (this.name()) {
      return this.name();
    }
    if (this.isSpacer()) {
      return 'Spacer';
    }
    if (this.index() === 0) {
      return 'Backbone';
    }
    return 'Insert';
  }

  type(): unknown {
    return this.get('type');
  }

  isSpacer(): boolean {
    return this.get('spacer') != null;
  }

  spacer(): string | null {
    return this.get('spacer');
  }

  warnings(): Array<string> {
    return this.get('warnings');
  }

  singleFragment(): Fragment {
    if (this.fragments().length !== 1) {
      throw new Error(`Unexpected number of fragments: ${this.fragments().length}`);
    }
    return this.fragments().at(0);
  }

  setSingleFragment(values: Partial<AssemblyWizardFragment>): JQueryPromise<void> {
    let fragment: Fragment;
    if (this.isEmpty()) {
      fragment = this.fragments().add(values);
    } else {
      fragment = this.singleFragment();
      fragment.set(values);
    }
    fragment.set({slot_id: this.get('id')});
    return fragment
      .save(null, {patch: true})
      .done(() => {
        const slotIndex = this.index();
        if (slotIndex === 0) {
          analytics.track('assembly', 'set_backbone', {
            product: ANALYTICS_MODULE.MOLBIO,
            actionCategory: ACTION_CATEGORY.WRITE,
          });
        } else {
          analytics.track('assembly', 'set_insert', {
            product: ANALYTICS_MODULE.MOLBIO,
            actionCategory: ACTION_CATEGORY.WRITE,
            slotIndex,
          });
        }
      })
      .fail(() =>
        fragment.destroy({
          error() {
            // Assert false for now to get a stack trace to help with debugging T571
            assertAndContinue(false, 'fragment.destroy() failed');
          },
        })
      );
  }

  shiftLeft(): void {
    this._shift(-1);
  }

  shiftRight(): void {
    this._shift(1);
  }

  _shift(delta: number): void {
    const newIndex = this.index()! + delta;
    const {collection} = this;
    if (newIndex < 0 || newIndex >= collection.length) {
      return;
    }
    collection.remove(this, {skipCheck: true} as Backbone.Silenceable);
    collection.add(this, {at: newIndex});
    // @ts-expect-error DefinitelyTyped requires collection: Collection<any> on Backbone.Model and this is
    // the lowest-effort place to suppress typing errors relating to this Model referencing non-default
    // methods on its collection
    collection.saveOrder();
  }

  parse(
    resp: ServerAssemblyWizardSlot
  ): Omit<ServerAssemblyWizardSlot, 'fragments'> & {fragments: Fragments} {
    const fragments: Fragments = this.fragments() || new Fragments();
    // @ts-expect-error With parse: true we can pass anything that passes the parse signature on the
    // collection's model
    fragments.reset(resp.fragments, {parse: true} as Backbone.Silenceable);
    return {...resp, fragments};
  }

  toJSON(): AssemblySlot {
    const json = super.toJSON(...arguments);
    // eslint-disable-next-line no-restricted-syntax
    return _.omit(json, 'active', 'prevFragment', 'nextFragment', 'sequenceFragment', 'thisFragment');
  }
}

AssemblySlot.initClass();

export class AssemblySlots extends Backbone.Collection<AssemblySlot> {
  assemblyID?: string;

  static initClass(): void {
    this.prototype.model = AssemblySlot;
    this.prototype.comparator = 'index';
  }

  initialize(models: Array<AssemblySlot>, param: {assemblyID?: string}): void {
    if (param == null) {
      param = {};
    }
    const {assemblyID} = param;
    this.assemblyID = assemblyID;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.on('add remove', this.reorder);
  }

  // @ts-expect-error Benchling.Collection.add is overloaded, where add(model: T) returns T and
  // add(models: Array<T>) returns Array<T>. An approach one might have taken had TypeScript been around when
  // one was developing one's framework would be to use generics. We are cleverly doing neither of these
  // things, and instead are always returning Array<T>, so I have to suppress yet another error.
  add(modelOrModels: Array<AssemblySlot> | AssemblySlot, options?: {at: number}): Array<AssemblySlot> {
    // eslint-disable-next-line no-restricted-syntax
    const models: Array<AssemblySlot> = _.isArray(modelOrModels) ? modelOrModels : [modelOrModels];
    if ((options != null ? options.at : undefined) != null) {
      this.each((p) => {
        if (p.index()! >= options!.at) {
          p.set({index: p.index()! + models.length});
        }
      });

      // eslint-disable-next-line no-restricted-syntax
      _.each(models, (model, i) => {
        model.set({index: options!.at + i});
      });
    }

    // @ts-expect-error not picking up on the correct overload
    return super.add(models, options) as Array<AssemblySlot>;
  }

  addSlot(values: AssemblyWizardSlot, index: number | null = null): Promise<void> {
    const slot = new AssemblySlot(values);
    slot.set({assembly_id: this.assemblyID});
    if (index != null) {
      slot.set({index});
    }

    if (index == null) {
      index = this.length;
    }
    const xhr = slot.save().done(() => {
      this.add(slot, {at: index});
      this.each((s) => s.set({active: s === slot}));
    });
    return xhr;
  }

  saveOrder(): void {
    // Relies on camparator keeping slots sorted by index.
    net
      .postJSON({
        url: `/1/api/assemblies/${this.assemblyID}/actions/reorder`,
        data: {order: this.map((slot) => slot.id)},
      })
      .fail(notifications.notifyError);
  }

  reorder(): void {
    // keep consistent with server side (sqlalchemy ordered list)
    this.each((p, i) => p.set({index: i}));
  }

  withoutSpacers(): Array<AssemblySlot> {
    return this.filter((slot) => !slot.isSpacer());
  }

  // Returns array of length = # of non-spacer slots
  // Position i is null if non-spacer slot i has no following spacer, and otherwise an annotated fragment
  // consisting of all spacers following non-spacer slot, but concatenated.
  getSpacers(): Array<BioJSSequence> {
    const biojs = require('BioJS'); // Circular dependency.
    // Pluck out features.
    const spacersWithNulls = this.map((slot) => {
      if (!slot.isSpacer()) {
        return null;
      }
      return {name: slot.displayName(), bases: slot.spacer()};
    });

    // Bucket into one element per non-spacer slot. It's easier to work backwards and use null-termination:
    // [null, 1, 2, null, 3, null] -> [[1, 2], [3], []]
    spacersWithNulls.reverse();
    const preFlattenSpacers = [];
    let thisItemArray = [];
    for (const item of Array.from(spacersWithNulls)) {
      if (item == null) {
        thisItemArray.reverse();
        preFlattenSpacers.push(thisItemArray);
        thisItemArray = [];
        continue;
      }
      thisItemArray.push(item);
    }
    preFlattenSpacers.reverse();
    assert(
      thisItemArray.length === 0,
      `spacersWithNulls did not start with a null, not all items \
accounted for`
    );
    assert(
      preFlattenSpacers.length === this.withoutSpacers().length,
      `preFlattenSpacers does not match up to \
non-spacer slots`
    );

    // Map to final product.
    // eslint-disable-next-line no-restricted-syntax
    const fragments = _.map(preFlattenSpacers, (items) => {
      if (items.length === 0) {
        return null;
      }
      const fragment = new biojs.Sequence();
      // Add bases and annotations.
      const annotations = fragment.annotations();
      for (const {name, bases} of Array.from(items)) {
        const oldLength = fragment.length();
        fragment.insertBases(oldLength, bases);
        // Avoid empty annotations.
        if (bases!.length > 0) {
          annotations.add({
            start: oldLength,
            end: 0,
            strand: 0,
            name,
          });
        }
      }
      return fragment;
    });
    return fragments;
  }
}

AssemblySlots.initClass();

export interface GibsonParameters {
  tmAnneal: number;
  tmDiff: number;
  tmWhole: number;
  maxOverlap: number;
  minOverlap: number;
}

export interface GoldenGateParameters {
  bindingRegionMinLength: number;
  bindingRegionMinTM: number;
  enzymeID: number;
  preRecognitionSiteBases: string;
  preRecognitionSiteLength: number;
  primerPairMaxTMDiff: number;
}

interface AssemblyWizardAssembly {
  name: string;
  active: boolean;
  slots: AssemblySlots;
  method: ASSEMBLY_TYPE | null;
  warnings: Array<string>;
  errors: Array<string>;
  parameters: GibsonParameters | GoldenGateParameters | {};
  provider: ProviderName;
}

type ServerAssemblyWizardAssembly = Omit<AssemblyWizardAssembly, 'slots'> & {
  slots: Array<ServerAssemblyWizardSlot>;
  id: string;
};

class Assembly extends Backbone.Model {
  static initClass(): void {
    this.prototype.urlRoot = '/1/api/assemblies/';
  }

  defaults(): AssemblyWizardAssembly {
    return {
      name: 'Untitled Assembly',
      active: false,
      slots: new AssemblySlots(),
      method: null,
      warnings: [],
      errors: [],
      parameters: {},
      provider: preferences.get(EnzymePreferences.PROVIDER),
    };
  }

  active(): boolean {
    return this.get('active');
  }

  method(): ASSEMBLY_TYPE | null {
    return this.get('method');
  }

  name(): string {
    return this.get('name');
  }

  parameters(): GibsonParameters | GoldenGateParameters | {} {
    return this.get('parameters');
  }

  slots(): AssemblySlots {
    return this.get('slots');
  }

  allFragments(): Array<Fragment> {
    return this.slots()
      .chain()
      .map((slot: AssemblySlot) => slot.fragments().models)
      .flatten()
      .value();
  }

  warnings(): Array<string> {
    return this.get('warnings');
  }

  errors(): Array<string> {
    return this.get('errors');
  }

  canCreate(): boolean {
    // Wait till all fragments have saved before allowing user to finalize assembly (ref T8292).
    if (this.allFragments().some((fragment) => fragment.id == null)) {
      return false;
    }
    return this.get('errors').length === 0 || this.get('canCreateWithErrors');
  }

  initialize(): void {
    // The slots collection gets swapped on save/parse
    this.listenTo(
      this.slots(),
      'reset',
      (collection: AssemblySlots, options: {skipCheck?: boolean} | null) => {
        this.check(options);
      }
    );
    this.listenTo(
      this.slots(),
      'add remove',
      (model: AssemblySlot, collection: AssemblySlots, options: {skipCheck?: boolean} | null) => {
        this.check(options);
      }
    );
    this.listenTo(this.slots(), 'slotChange', (options: {skipCheck?: boolean} | null) => {
      this.check(options);
    });
    this.on(
      'change:parameters',
      function (
        model: Assembly,
        value: GibsonParameters | GoldenGateParameters,
        options: {skipCheck?: boolean} | null
      ) {
        // @ts-expect-error Shadows outer this
        this.check(options);
        // @ts-expect-error Shadows outer this
        this.setEnzymes();
      }
    );
  }

  // @ts-expect-error DefinitelyTyped has clone typed as returning `this` which we are obviously not doing
  clone(): JQueryPromise<Assembly> {
    // Assembly is cloned server-side to cut down on back-and-forth & race conditions
    return net
      .post({url: `${this.urlRoot}${this.get('id')}/actions/clone`})
      .then((response) => new Assembly(response, {parse: true}));
  }

  check(options?: {skipCheck?: boolean} | null): void {
    if (options == null) {
      options = {};
    }
    if (options.skipCheck) {
      return;
    }
    const asm = require('assembly/Asm').default;
    const {canCreateWithErrors, errors, warnings} = asm.for(this.method()).checkAssembly(this);

    this.set({canCreateWithErrors, errors, warnings});
    this.trigger('resize');
  }

  enzyme(): Enzyme {
    return COMMON_ENZYMES.get((this.parameters() as GoldenGateParameters).enzymeID);
  }

  setEnzymes(): void {
    // Handles setting enzymes active for Golden Gate.
    if (this.method() !== ASSEMBLY_TYPE.GOLDEN_GATE) {
      return;
    }

    // Activate enzymes in fragments.
    const previousParameters = this.previous('parameters');
    const previousEnzymeID = previousParameters.enzymeID;
    const {enzymeID} = this.parameters() as GoldenGateParameters;
    const filestates = require('FileStates').default.get();
    for (const sequence of Array.from<Sequence>(filestates.getOpenSequences())) {
      const enzymes = sequence.get('enzymes');
      const enzyme = enzymes.get(enzymeID);
      enzyme.set({active: true});
      if (previousEnzymeID != null && previousEnzymeID !== enzymeID) {
        const previousEnzyme = enzymes.get(previousEnzymeID);
        previousEnzyme.set({active: false});
      }
    }
  }

  parse(resp: ServerAssemblyWizardAssembly, options: {parse: boolean}): AssemblyWizardAssembly | null {
    let slots;
    if (options.parse === false) {
      // its okay if undefined
      return null;
    }
    const existingSlots = this.slots();
    if (existingSlots) {
      slots = existingSlots;
      slots.assemblyID = resp.id;
    } else {
      slots = new AssemblySlots([], {assemblyID: resp.id});
    }
    // @ts-expect-error reset is overloaded in Backbone to accept the bare object if parse is true  but TS
    // isn't picking up the right overload
    slots.reset(resp.slots, {parse: true} as Backbone.Silenceable);
    return {...resp, slots};
  }

  toJSON(): Omit<AssemblyWizardAssembly, 'active'> {
    const json = super.toJSON(...arguments);
    // eslint-disable-next-line no-restricted-syntax
    return _.omit(json, 'active');
  }
}

Assembly.initClass();

// @ts-expect-error Assembly implements clone incorrectly, returning a promise instead of an Assembly instance
class Assemblies extends BenchlingCollection<Assembly> {
  _isFetching!: boolean;
  _loaded!: boolean;

  static initClass(): void {
    this.prototype.url = '/1/api/assemblies/';
  }

  initialize(): void {
    // We need to store explicit loaded states here, since it's not obvious
    // what 0 assemblies in a collection means. It could either mean that the data
    // hasn't loaded yet, or that the user has 0 assemblies.
    this._isFetching = false;
    this._loaded = false;
  }

  // @ts-expect-error DefinitelyTyped has this as returning JQueryXHR
  fetch(options?: {parse?: boolean; reset?: boolean}): JQueryPromise<void> {
    this._isFetching = true;
    return super
      .fetch(options)
      .always(() => {
        this._isFetching = false;
      })
      .done(() => {
        this._loaded = true;
        // We need to trigger another event here, since the e.g. "reset" event would have
        // already happened before we get a chance to mark _loaded as true.
        this.trigger('finishedFetch');
      })
      .fail(notifications.notifyError);
  }

  isFetching(): boolean {
    return this._isFetching;
  }

  isLoaded(): boolean {
    return this._loaded;
  }

  parse(resp: Array<AssemblyWizardAssembly>): Array<Assembly> {
    return resp.map((assembly) => new Assembly(assembly, {parse: true}));
  }

  toggleActive(assembly: Assembly, options?: Backbone.ModelSetOptions): void {
    this.each((model) => {
      const active = model === assembly && !assembly.active();
      model.set({active}, options);
    });
  }

  activateAssembly(assembly: Assembly): void {
    if (assembly.active()) {
      return;
    }
    const asm = require('assembly/Asm').default;
    const fileStates = require('FileStates').default.get();

    // We do this check client-side (for now), since we can't do a cascade delete from sequence -> fragment
    const fragmentsToDelete = assembly.allFragments().filter((frag: Fragment) => frag.sequenceID() == null);
    for (const fragment of Array.from<Fragment>(fragmentsToDelete)) {
      fragment.destroy({
        error() {
          // Assert false for now to get a stack trace to help with debugging T571
          assertAndContinue(false, 'fragment.destroy() failed');
        },
      });
    }
    const unloadedFragments = assembly
      .allFragments()
      .filter((frag) => fileStates.get(frag.sequenceID()) == null);

    let whenAllLoaded: Promise<Array<PromiseSettledResult<void>>> | null = null;
    const plugin = asm.for(assembly.method());
    if (plugin.shouldOpenSequenceFiles() && unloadedFragments.length > 0) {
      const slot = assembly.slots().find((slot) => !slot.isEmpty());
      const openSequenceId = slot.fragments().at(0).sequenceID();
      LoadingScreen.show();

      const xhrs = unloadedFragments.map((fragment) => {
        const xhr = fileStates.openFolderItem(fragment.sequenceID(), {open: false});
        // If a sequence can't be found for some reason (most likely deleted, or permission issues),
        // then just delete the fragment.
        xhr.fail((response: GenericResponseJSON) => {
          if (response.status === 404) {
            fragment.destroy({
              error() {
                // Assert false for now to get a stack trace to help with debugging T571
                assertAndContinue(false, 'fragment.destroy() failed');
              },
            });
          }
        });
        return xhr;
      });

      whenAllLoaded = Promise.allSettled(xhrs);
      whenAllLoaded.then((statuses) => {
        LoadingScreen.hide();
        fileStates.openFolderItem(openSequenceId);
        // Promise.allSettled returns a promise that will always fulfill, so we check if any of
        // the input promises rejected (meaning the sequence 404'd)
        // @ts-expect-error However, we should be looking at status.status here, not status.state, which does
        // not exist on PromiseSettledResult
        if (_.any(statuses, (status) => status.state === 'rejected')) {
          notifications.warn(`Some sequences used by this assembly could not be found, so their \
fragments have been reset`);
        }
      });
    }

    Promise.resolve(whenAllLoaded).finally(() => {
      assembly.allFragments().forEach((frag) => {
        if (!frag.isValid()) {
          frag.destroy({skipCheck: true} as Backbone.ModelDestroyOptions);
        }
      });
      assembly.check();
      this.toggleActive(assembly);
      analytics.track('assembly', 'opened_wizard', {
        product: ANALYTICS_MODULE.MOLBIO,
        actionCategory: ACTION_CATEGORY.WRITE,
        assemblyID: assembly.get('id'),
      });
    });
  }
}

Assemblies.initClass();

export const assemblies = new Assemblies();
export {Assemblies as __Assemblies, Fragment as __Fragment, Assembly, AssemblySlot as AssemblySlotType};
